import { IApplicationState } from '../types/redux';

export const selectSuburbanPromoBlock = (state: IApplicationState) =>
  state.mainpage.promoBlocks.find(({ id }) => id === 'indexSuburban');
